import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { SearchResultComponent } from '@softapps/core/pages';

interface Lagersymbol {
  addlagerstand: number;
  aktiv: string;
  bezeichnung: string;
  id: number;
  kzabfallbilanz: string;
  kzaddlager: 'J' | 'N' | string;
  kzbelegart: 'B' | string;
  kznachkalk: string;
  kzpalette: 'N' | 'J' | string;
  lagersymbol: string;
}

@Component({
  selector: 'soft-field-ok-lagersym-search-result-view',
  imports: [],
  templateUrl: './search-result-view.component.html',
  styleUrl: './search-result-view.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush })
export class LagersymFieldOkSearchResultViewComponent
  implements SearchResultComponent<Lagersymbol>
{
  readonly result = input.required<Lagersymbol>();
}
